import { render } from "./LabeledUserDropDown.vue?vue&type=template&id=1b9dddbe&scoped=true"
import script from "./LabeledUserDropDown.vue?vue&type=script&lang=js"
export * from "./LabeledUserDropDown.vue?vue&type=script&lang=js"

import "./LabeledUserDropDown.vue?vue&type=style&index=0&id=1b9dddbe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1b9dddbe"

export default script